// Copyright (c) 2016 Deere & Company

import './show-no-results-found.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const ShowNoResultsFound = props =>
    <div>
        {props.showNoResultsFound ?
            <div className='help-text'>
                <FormattedMessage id='NO_RESULTS_FOUND'/>
            </div> :
         null}
    </div>;

ShowNoResultsFound.displayName = 'ShowNoResultsFound';
ShowNoResultsFound.propTypes = {
    showNoResultsFound: PropTypes.bool.isRequired
};

export default ShowNoResultsFound;



// WEBPACK FOOTER //
// ./src/reports/shared/components/show-no-results-found/show-no-results-found.js